import { INotification } from '@/services/Notification/notifications.types.ts'
import { useLayoutEffect } from 'react'

interface IProps {
  elements: { element: HTMLElement; id: INotification['id']; seen: INotification['seen'] }[]
  active: boolean
  handleViewedNotification: (id: INotification['id']) => void
  viewedNotifications: Set<INotification['id']>
  refreshKey?: string | null
}

const useObserveElementsByIntersection = (props: IProps) => {
  useLayoutEffect(() => {
    if (props.elements?.length === 0 || !props.active) return
    const observers = []
    props.elements.forEach((item) => {
      if (item.element === null) return
      const observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !props.viewedNotifications.has(item.id) && !item.seen) {
              props.viewedNotifications.add(item.id)
              observer.unobserve(item.element)
            }
          })
        },
        { threshold: 1 }
      )

      observer.observe(item.element)
      observers.push(observer)
    })

    return () => {
      observers.forEach((observer) => observer.disconnect())
    }
  }, [props.elements, props.active, props.refreshKey])
}

export default useObserveElementsByIntersection
